import { createUseStyles } from 'react-jss';

import { flex } from '@resources/mixins';
import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    wrapper: {
        backgroundColor: theme.colors.white,
        padding: `${theme.spacing(8)} ${theme.spacing(6)}`,
        border: `1.5px solid ${theme.colors.grey_light}`,
        borderRadius: theme.radius,
        marginTop: theme.spacing(6),
    },

    heading: {
        color: theme.colors.text_heading,
        fontSize: 18,
        fontWeight: 600,
        marginBottom: theme.spacing(2),
    },

    subtitle: {
        color: theme.colors.grey_text,
        marginBottom: theme.spacing(6),
    },

    empty: {
        color: theme.colors.grey_text,
    },

    device: {
        ...flex('row', 'space-between', 'center'),
        gap: theme.spacing(4),
        padding: `${theme.spacing(4)} 0`,
        borderTop: `1px solid ${theme.colors.grey_light}`,
    },

    deviceName: {
        color: theme.colors.text_heading,
        fontWeight: 600,
        wordBreak: 'break-word',
    },

    deviceMeta: {
        color: theme.colors.grey_text,
        marginTop: theme.spacing(1),
        wordBreak: 'break-word',
    },
}));
